import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown, Popover, Row, Col, Tab, Nav } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LoadingComponent from '../../../layouts/nav/loading';

import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const DeadVerification = () => {

    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ----------------------- branch --------------------
        man_branch: 0,
        branch_list: 0,
        branch_add: 0,
        branch_edit: 0,
        branch_view: 0,
        branch_delete: 0,
        branch_add_staff: 0,
        branch_add_area: 0,
        branch_add_dpoint: 0,
        branch_asign_manager: 0,
        branch_asign_cug: 0,

        man_dpoint: 0,
        dpoint_list: 0,
        dpoint_edit: 0,
        dpoint_delete: 0,
        dpoint_assign_vehicle: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [loading, setLoading] = useState(false);

    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [total_entries, setTotslEntries] = useState(0);
    const [verified, setverified] = useState(0);
    const [unverified, setunverified] = useState(0);

    const [total_lead, setTotalLead] = useState(0);
    const [total_spam, setTotalSpam] = useState(0);
    const [total_dead, setTotalDead] = useState(0);
    const [total_call, settotalCall] = useState(0);
    const [total_followup, setTotalfollowup] = useState(0);

    useEffect(() => {
        const params = {
            branch_id: branch_id
        };
        axios.get(`${baseURL}/lead/counts`, { params: params })
            .then(response => {
                setTotalLead(response.data.lead);
                setTotalSpam(response.data.spam);
                setTotalDead(response.data.dead);
                setTotalfollowup(response.data.today_followup_count);
                settotalCall(response.data.internal_call);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });
    }, []);

    // page table data fetch
    const fetchData = (filter = {}) => {
        setLoading(true);
        const params = {
            ...filter,      // spread existing filter key-values
            page,           // add page number
            per_page: perPage, // add per_page
            search: searchTerm,  // add search string
            branch_id: branch_id
        };
        axios.get(`${baseURL}/lead/dead`, { params: params })
            .then(response => {
                setData(response.data.data);
                setHasFetched(true);
                setTotalPages(response.data.last_page);
                setTotslEntries(response.data.total);
                setverified(response.data.verified);
                setunverified(response.data.not_verified);
                setLoading(false);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    };

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);

    const tableRef = useRef(null);

    const toggle_status_change = (id, lable, data) => {
        swal.fire({
            html: `
                    <div class="alert alert-info px-2 py-2" role="alert">
                        Are You Sure Want to Change Status
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                    <div class="row mb-2 text-center">
                        <label class="text-black font-w300"><b>${data.lead_name} - ${data.mobile_no}</b></label>
                    </div>
                    <div class="text-center mt-4 mb-3">
                        <label class="fw-bold text-green fs-2">${lable}</label>
                    </div>
                `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.put(`${baseURL}/managelead/status/${data.sno}`, { lead_status: id })
                    .then((result) => {
                        // window.location.reload();
                        fetchData();
                        toast.success("Lead Status Changed Successfully!");
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("Lead Status Change Failed");
                    });
            }
        });
    };

    const handleModalToggleDead = (id, label, data) => {
        // Generate options dynamically

        swal.fire({
            html: `
                <div class="alert alert-info px-2 py-2" role="alert">
                    Are You Sure Want to Change Status
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <div class="row mb-2 text-center">
                    <label class="text-black font-w300"><b>${data.lead_name} - ${data.mobile_no}</b></label>
                </div>
                <div class="text-center mt-4 mb-3">
                    <label class="fw-bold text-green fs-2">${label}</label>
                </div>
                <div class="form-group text-start mt-3">
                    <label for="reasonSelect" class="form-label">Enter Reason<span class="required">*</span></label>
                   <input type="text" id="reasonInput" class="form-control" placeholder="Enter reason here">
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,

            preConfirm: () => {
                const reason = document.getElementById('reasonInput').value;
                if (!reason) {
                    swal.showValidationMessage('Please Enter a reason');
                    return false;
                }
                return { reason };
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                axios.put(`${baseURL}/managelead/status/${data.sno}`, {
                    lead_status: id,
                    verification_reason: result.value.reason
                })
                    .then((result) => {
                        // window.location.reload();
                        fetchData();
                        toast.success("Lead Status Changed Successfully!");
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error("Lead Status Change Failed");
                    });
            }
        });
    };

    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    const [key, setKey] = useState('dead');

    function capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const [isMaintenance, setIsMaintenance] = useState(false);
    // const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "managelead"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    // if (loading) {
    //     return <div>Loading...</div>; // optional loading state
    // }

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Branch</strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>
            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 className='breadcrumb-header'>Manage Lead</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Lead Management</li>
                        </ol>
                    </div>
                </div>
            )}

            {/* <LoadingComponent loading={loading} /> */}

            {loading ? (
                <Col xl={12} className='mb-3'>
                    <div className="custom-tab-1">
                        <Nav as="ul" className="nav-tabs">
                            {[1, 2, 3, 4].map((_, index) => (
                                <Nav.Item as="li" key={index}>
                                    <Nav.Link disabled className="d-flex align-items-center">

                                        <Skeleton circle width={20} height={20} />

                                        <div className="ms-2">
                                            <Skeleton width={80} height={14} />
                                        </div>

                                        <div className="ms-2">
                                            <Skeleton width={30} height={18} borderRadius={12} />
                                        </div>
                                    </Nav.Link>
                                </Nav.Item>
                            ))}
                        </Nav>
                    </div>
                </Col>
            ) : (
                <Col xl={12} className='mb-3'>
                    <div className="custom-tab-1">
                        <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                            <Nav as="ul" className="nav-tabs">
                                <Nav.Item as="li" >
                                    <Nav.Link as={Link} to="/manage-lead">
                                        <i class="fa-solid fa-users"></i>
                                        <label className="ms-2 fs-6">
                                            Lead
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-success ms-2 fw-bold fs-8'>
                                            {total_lead}
                                        </Badge>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" >
                                    <Nav.Link as={Link} to="/manage-spam-lead">
                                        <i class="fa-solid fa-users-slash"></i>
                                        <label className="ms-2 fs-6">
                                            Spam Lead
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-warning ms-2 fw-bold fs-8'>
                                            {/* {responses.closed_followup_count} */}
                                            {total_spam}
                                        </Badge>
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" >
                                    <Nav.Link eventKey="dead">
                                        <i class="fa-solid fa-users-rays"></i>
                                        <label className="ms-2 fs-6">
                                            Dead Lead
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                            {/* {responses.reschedule_followup_count} */}
                                            {total_dead}
                                        </Badge>
                                    </Nav.Link>
                                </Nav.Item>
                                {/* <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-internal-call">
                                    <i class="fa-solid fa-group-arrows-rotate"></i>
                                    <label className="ms-2 fs-6">
                                        Internal Call
                                    </label>
                                    <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                        {total_call}
                                    </Badge>
                                </Nav.Link>
                            </Nav.Item> */}
                                <Nav.Item as="li" >
                                    <Nav.Link as={Link} to="/manage-today-followup">
                                        <i class="fa-solid fa-calendar-day"></i>
                                        <label className="ms-2 fs-6">
                                            Today Followup
                                        </label>
                                        <Badge as="a" href="" bg=" badge-circle" className='badge-outline-info ms-2 fw-bold fs-8'>
                                            {/* {responses.unfollowup_count} */}
                                            {total_followup}
                                        </Badge>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Tab.Container>
                    </div>
                </Col>
            )}

            {loading ? (
                <div className="row mb-3">
                    <div className="d-flex align-items-end justify-content-end">
                        {/* Verified Spam Box */}
                        <div className="me-2">
                            <div
                                className="border rounded px-3 py-1 text-center"
                                style={{ width: 140, height: 80 }}
                            >
                                <Skeleton width={90} height={14} />

                                <div className="mt-3">
                                    <Skeleton width={50} height={26} />
                                </div>
                            </div>
                        </div>

                        {/* Not Verify Spam Box */}
                        <div className="me-2">
                            <div
                                className="border rounded px-3 py-1 text-center"
                                style={{ width: 140, height: 80 }}
                            >
                                <Skeleton width={110} height={14} />

                                <div className="mt-3">
                                    <Skeleton width={50} height={26} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className='row mb-3'>
                    <div className='d-flex align-items-end justify-content-end'>
                        <div className='me-2'>
                            <div className='border rounded px-3 py-1 border-success bg-success-light'>
                                <label className='text-black fs-6'>Verified Dead Lead</label>
                                <div className='d-block text-center'>
                                    <label className="text-danger fs-3 m-0 fw-bold">
                                        {/* <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span> */}
                                        <span>{verified}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='me-2'>
                            <div className='border rounded px-3 py-1 border-danger bg-danger-light '>
                                <label className='text-black fs-6'>Not Verify Dead Lead</label>
                                <div className='d-block text-center'>
                                    <label className="text-danger fs-3 m-0 fw-bold">
                                        {/* <span><i class="fa-solid fa-indian-rupee-sign me-1"></i></span> */}
                                        <span>{unverified}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )}

            {loading ? (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center">
                            <Skeleton width={40} height={12} className="me-2" />
                            <Skeleton width={60} height={28} borderRadius={4} />
                        </div>

                        <Skeleton width={180} height={36} borderRadius={4} />
                    </div>

                    <table
                        className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
                        style={{ borderBottom: "2px solid #ddd" }}
                    >
                        <thead>
                            <tr>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                                <th><Skeleton width={100} height={16} /></th>
                            </tr>
                        </thead>

                        <tbody>
                            {[...Array(25)].map((_, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td>
                                        <Skeleton width={120} height={14} />
                                    </td>

                                    <td className="text-start">
                                        <Skeleton width={100} height={14} />
                                    </td>

                                    <td className="text-start">
                                        <Skeleton width={100} height={14} />
                                        <div className="mt-1">
                                            <Skeleton width={70} height={10} />
                                        </div>
                                    </td>

                                    <td className="text-start">
                                        <Skeleton width={140} height={12} />
                                        <div className="mt-1">
                                            <Skeleton width={100} height={10} />
                                        </div>
                                    </td>

                                    <td className="text-center">
                                        <Skeleton width={100} height={20} borderRadius={10} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <Skeleton width={200} height={12} />

                        <div className="d-flex align-items-center gap-2">
                            {[1, 2, 3, 4].map((_, index) => (
                                <Skeleton
                                    key={index}
                                    width={40}
                                    height={26}
                                    borderRadius={4}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            ) : (
                <div className="table-container">

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{ fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); // Reset to first page
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{ fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>

                    <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                        <thead>
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                                <th className='min-w-100px'>Lead</th>
                                <th className='min-w-100px text-start'>Mobile Number</th>
                                <th className='min-w-80px text-start'>Sales Person</th>
                                <th className='min-w-50px text-start'>Reason</th>
                                <th className='min-w-50px text-center'>Status</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                            {datas.length === 0 && hasFetched ? (
                                <tr>
                                    <td colSpan="5" className="text-center text-muted py-2">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {datas.map((data, index) => (
                                        <tr key={data.sno}>
                                            <td>
                                                <div className='text-black font-w400 fs-7 text-wrap mw-75'>{capitalizeFirstLetter(data.lead_name)}</div>
                                            </td>
                                            <td className='text-start'>
                                                <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.mobile_no}</div>
                                            </td>
                                            <td className='text-start'>
                                                <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.sales_person ? data.sales_person : '-'}</div>
                                                <div className='d-block'>
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Lead Source</span></Tooltip>} >
                                                        <div className='text-info font-w600 fs-8 text-wrap mw-75'>{data.lead_sources_name}</div>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>
                                            <td className='text-start'>
                                                <div class="text-truncate max-w-200px text-black fw-semibold fs-7">{data.conversion_reason ? data.conversion_reason : '-'}</div>
                                                {data.verification_reason && (
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.verification_reason}</span></Tooltip>} >
                                                        <div className='text-truncate mw-300px text-dark font-w400 fs-7'>[ {data.verification_reason} ]</div>
                                                    </OverlayTrigger>
                                                )}
                                            </td>
                                            <td className='text-center'>
                                                {data.lead_status === 6 ? (
                                                    <Dropdown drop="">
                                                        <Dropdown.Toggle as="a" className={`i-false ${permissions.lead_approve_dead === 1 ? 'cursor-pointer' : ''} `}>
                                                            <Badge bg="none" className='py-1 px-2 fs-8 text-black' style={{ background: '#aaaaaaff' }}>Waiting for Approval</Badge>
                                                        </Dropdown.Toggle>
                                                        {permissions.lead_approve_dead === 1 && (
                                                            <Dropdown.Menu >
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => handleModalToggleDead(2, 'Dead', data)}>Verify Dead</Dropdown.Item>
                                                                <Dropdown.Item href="#" className='text-black' onClick={() => toggle_status_change(1, 'Active Lead', data)}>Convert Lead</Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        )}
                                                    </Dropdown>
                                                ) : (
                                                    <Badge bg="none" className='py-1 px-2 fs-8 bg-success text-white'>Approved</Badge>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {datas.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {total_entries} entries
                                </span>
                            ) : (
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                    </li>
                                ))}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>

                    </div>

                </div>
            )}

        </>
    )


}

export default DeadVerification;